import React,{useEffect,useState} from "react";
// Both inputs share one indexed server lookup. Never copy the UK nation into State.
export default function UKPostalInput({value,onChange,onPick,postcode=false,required=false}){
 const [items,setItems]=useState([]),[open,setOpen]=useState(false),[typed,setTyped]=useState(false),[active,setActive]=useState(0),[note,setNote]=useState(""),[next,setNext]=useState(""),[loadingMore,setLoadingMore]=useState(false);
 useEffect(()=>{
  if((!typed && !(postcode && /^[A-Za-z]{1,2}[0-9][A-Za-z0-9]?$/.test(String(value||"").trim()))) || String(value||"").trim().length<2){setItems([]);setNext("");return;}
  const controller=new AbortController();
  const timer=setTimeout(async()=>{
   try{
    const r=await fetch("/api/geo/countries/GB/postcodes?q="+encodeURIComponent(value),{signal:controller.signal,cache:"no-store"});
    if(!r.ok)throw new Error("lookup");
    const d=await r.json();setItems(d.items||[]);setNext(d.next||"");setActive(0);setOpen(true);
    setNote(d.items?.length ? (d.more?"Choose a full postcode below, or type to narrow the list.":"") : "No postcode match. You can enter the town and postcode manually.");
   }catch(e){if(e.name!=="AbortError")setNote("Postcode lookup unavailable. Please enter the address manually.");}
  },250);
  return()=>{clearTimeout(timer);controller.abort();};
 },[value,typed]);
 const more=async()=>{
  if(!next||loadingMore)return;
  setLoadingMore(true);
  try{
   const r=await fetch("/api/geo/countries/GB/postcodes?q="+encodeURIComponent(value)+"&after="+encodeURIComponent(next),{cache:"no-store"});
   if(!r.ok)throw new Error("lookup");
   const d=await r.json();
   setItems(old=>{const seen=new Set(old.map(x=>x.postcode));return [...old,...(d.items||[]).filter(x=>!seen.has(x.postcode))];});
   setNext(d.next||"");
  }catch{setNote("Could not load more postcodes. Please try again.");}
  finally{setLoadingMore(false);}
 };
 const pick=item=>{setTyped(false);setOpen(false);setNote("");onPick(item);};
 return <div className="hsf-sugg">
  <input className="hsf-input" value={value||""} required={required}
   pattern={postcode?"(?:[A-Za-z]{1,2}[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|GIR ?0AA)":undefined} title={postcode?"Enter the complete UK postcode, e.g. SM1 4FW":undefined}
   aria-label={postcode?"UK postcode":"UK town or postcode"} autoComplete={postcode?"postal-code":"address-level2"}
   placeholder={postcode?"e.g. SM1 4FW":"Town or postcode"}
   role="combobox" aria-expanded={open&&items.length>0} aria-controls={postcode?"uk-postcode-results":"uk-town-results"}
   onChange={e=>{setTyped(true);onChange(postcode?e.target.value.toUpperCase():e.target.value);}}
   onBlur={()=>setOpen(false)} onFocus={()=>{if(typed || items.length)setOpen(true);}}
   onKeyDown={e=>{
    if(!open||!items.length)return;
    if(e.key==="ArrowDown"){e.preventDefault();setActive(n=>Math.min(n+1,items.length-1));}
    if(e.key==="ArrowUp"){e.preventDefault();setActive(n=>Math.max(0,n-1));}
    if(e.key==="Enter"){e.preventDefault();pick(items[active]);}
    if(e.key==="Escape")setOpen(false);
   }}/>
  {open&&items.length>0&&<div className="hsf-sugg-list" role="listbox" id={postcode?"uk-postcode-results":"uk-town-results"}>
   {items.map((item,i)=><button key={item.postcode} type="button" role="option" aria-selected={i===active}
    className={"hsf-sugg-item"+(i===active?" active":"")} onMouseDown={e=>e.preventDefault()} onClick={()=>pick(item)}>
    {item.label}{item.nation&&<small style={{display:"block"}}>{item.nation}</small>}
   </button>)}
   {next&&<button type="button" className="hsf-sugg-item" disabled={loadingMore} onMouseDown={e=>e.preventDefault()} onClick={more}>{loadingMore?"Loading…":"Show more postcodes"}</button>}
  </div>}
  {note&&<small role="status">{note}</small>}
  <small style={{display:"block",fontSize:10}}><a href="https://www.geonames.org/" target="_blank" rel="noreferrer">GeoNames</a> · Contains Royal Mail data © 2022</small>
 </div>;
}

export function UKCountyInput({value,onChange}){
 useEffect(()=>{if(["England","Scotland","Wales","Northern Ireland"].includes(value))onChange("");},[value]);
 return <input className="hsf-input" value={value||""} onChange={e=>onChange(e.target.value)} autoComplete="address-level1"/>;
}
